import { AxiosInstance } from "axios";
import { Ile } from "../types/Ile";

export const ileService = {
  getAll: async (api: AxiosInstance): Promise<Ile[]> => {
    try {
      const response = await api.get('/ile');
      return response.data as Ile[];
    } catch (error: any) {
      console.error('Erreur lors de la récupération des îles :', error);
      return [];
    }
  }
};
